module.exports = __webpack_public_path__ + "img/615.575f4800.png";